// src/components/claims/CollapsiblePanel.jsx
// The frame shared by «Affermazioni nel testo» and «Fonti consultate»: a header button
// (icon, title, chips, chevron, then a one-line description of what the panel is for)
// that opens and closes the body. `initiallyOpen` is read once (useState initialiser).
// `t` / `w` are the host's theme text colours and alpha helper (dark run card, light
// run detail page).
import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { COLORS, FONT_MONO, RADII } from '../../constants/theme.js';

export default function CollapsiblePanel({
  icon: Icon, title, description, chips = null, initiallyOpen = false, bodyId, t = {}, w = (o) => `rgba(0,0,0,${o})`,
  children,
}) {
  const [open, setOpen] = useState(() => initiallyOpen);
  const muted = t.textMuted || COLORS.textSecondary;
  return (
    <div style={{ borderRadius: RADII.control, border: `1px solid ${w(0.06)}`, overflow: 'hidden' }}>
      <button
        type="button"
        aria-expanded={open}
        aria-controls={open ? bodyId : undefined}
        onClick={() => setOpen((o) => !o)}
        style={{
          display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: '4px', width: '100%',
          padding: '10px 16px', background: w(0.02), border: 'none', cursor: 'pointer', textAlign: 'left',
        }}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          {Icon && <Icon size={13} color={COLORS.accent} strokeWidth={1.5} />}
          <span style={{ fontSize: '11px', fontFamily: FONT_MONO, fontWeight: 600, color: COLORS.accent }}>{title}</span>
          {chips}
          <span style={{ marginLeft: 'auto' }}>
            {open ? <ChevronUp size={14} color={muted} /> : <ChevronDown size={14} color={muted} />}
          </span>
        </span>
        {description && <span style={{ fontSize: '11.5px', color: muted }}>{description}</span>}
      </button>
      {open && (
        <div id={bodyId} style={{ padding: '10px 16px 14px' }}>
          {children}
        </div>
      )}
    </div>
  );
}
